(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo/assets/javascripts/views/play/game-promo.js') >= 0) return;  svs.modules.push('/modules/bingo/assets/javascripts/views/play/game-promo.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.bingo.views.GamePromo = Marionette.View.extend({
    preventUpdate: false,

    ui: {
      promoBackground: '.bingo-game-promo',
      bingoGameStateDate: '#bingoGameStateDate'
    },

    events: {
      setPreventUpdate: 'onSetPreventUpdate'
    },

    onAttach: function() {
      this.model.get('infoBar').on('change:date', this.updateTime, this);
      this.model.get('infoBar').on('change:users', this.updateUsers, this);
    },

    template: function(data) {
      return svs.bingo.templates.game_promo(data);
    },

    templateContext: function() {
      return {
        price: this.model.get('infoBar').get('price'),
        users: this.model.get('infoBar').get('users'),
        date: this.model.get('infoBar').get('date'),
        bingoType:
          this.model.get('textRows').length && this.model.get('textRows')[3],
        images: this.model.get('backgroundImageLarge')
      };
    },

    updateTime: function() {
      this.preventUpdate ||
        this.getUI('bingoGameStateDate').text(this.model.get('infoBar').get('date'));
    },
    onDomRefresh: function() {
      this.getUI('bingoGameStateUsers');
    },

    updateUsers: function() {
      this.preventUpdate ||
        this.getUI('bingoGameStateUsers').text(this.model.get('infoBar').get('users'));
    },

    onSetPreventUpdate: function(state) {
      this.preventUpdate = Boolean(state);
    },

    onDestroy: function() {
      this.model.get('infoBar').off('change:date', this.updateTime, this);
      this.model.get('infoBar').off('change:users', this.updateUsers, this);
    }
  });
})(Backbone, _, svs);


 })(window);